import React, { useState, useEffect, useMemo } from 'react'
import { Dropdown, OverlayTrigger, Tooltip, Button, Modal, Form } from 'react-bootstrap'
import Card from '../../../../components/Card'
import CustomToggle from '../../../../components/dropdowns'
import ShareOffcanvas from '../../../../components/share-offcanvas'
import { InView } from "react-intersection-observer";
import { Link, useNavigate, Route } from 'react-router-dom'
import { apiHandler } from '../../../../api/apihandler';
import { GENERAL_SETTINGS, GET_MY_ADS } from "../../../../api/constants";
import Swal from 'sweetalert2'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
// import state selectors
import { setUserData } from '../../../../store/setting/actions'

//image
import user1 from '../../../../assets/images/user/1.jpg'
import user3 from '../../../../assets/images/user/03.jpg'
import user4 from '../../../../assets/images/user/04.jpg'
import img1 from '../../../../assets/images/small/07.png'
import img2 from '../../../../assets/images/small/08.png'
import img3 from '../../../../assets/images/small/09.png'
import img4 from '../../../../assets/images/small/10.png'
import img5 from '../../../../assets/images/small/11.png'
import img6 from '../../../../assets/images/small/12.png'
import img7 from '../../../../assets/images/small/13.png'
import img8 from '../../../../assets/images/small/14.png'
import p1 from '../../../../assets/images/page-img/p1.jpg'
import p2 from '../../../../assets/images/page-img/p2.jpg'
import p3 from '../../../../assets/images/page-img/p3.jpg'
import p4 from '../../../../assets/images/page-img/p4.jpg'
import p5 from '../../../../assets/images/page-img/p5.jpg'
import small6 from '../../../../assets/images/small/12.png'
import loader from '../../../../assets/images/page-img/page-load-loader.gif'
import video from '../../../../assets/images/small/video.png'
import LoaderModal from '../../../../components/loaderModal'
import AdCard from '../../../../components/ads/adCard'
import CreateNewAd from '../../../../components/ads/createNewAd'
import PeopleYouMayKnowWidget from '../../../../components/nemonto/PeopleYouMayKnowWidget'
import MyStatsWidget from '../../../../components/nemonto/MyStatsWidget'
import PromoCard from '../../../../components/nemonto/PromoCard'
import EmptyState from '../../../../components/nemonto/EmptyState'
import '../../social/social-list-page.css'

const AD_TIPS = [
    {
        title: "Ads with real photos perform best",
        sub: "Posts with a clear recipe photo get noticeably more clicks than text-only ads.",
        ctaText: "See challenges for inspiration",
        to: "/dashboards/app/influencer-challenges",
    },
    {
        title: "Keep your headline short and specific",
        sub: "Short, concrete titles outperform vague ones — say what the dish is, not just that it's tasty.",
        ctaText: "See challenges for inspiration",
        to: "/dashboards/app/influencer-challenges",
    },
    {
        title: "Post when your audience is active",
        sub: "Ads placed during peak browsing hours tend to get more engagement.",
        ctaText: "See challenges for inspiration",
        to: "/dashboards/app/influencer-challenges",
    },
]

const FriendList = () => {
    // let profileData = (useSelector((state) => state.setting.setting.user_data))
    // profileData = profileData ? JSON.parse(profileData) : "";
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const dispatch = useDispatch()
    const [showCreateAdModal, setShowCreateAdModal] = useState(false);
    const [adsList, setAdsList] = useState([]);
    const [generalSettings, setGeneralSettings] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const adTip = useMemo(() => AD_TIPS[Math.floor(Math.random() * AD_TIPS.length)], []);
    const handleClose = () => setShowCreateAdModal(false);

    const [isFirst, setIsFirst] = useState(true);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsFirst(false)
    }, [isFirst]);

    useEffect(() => {
        if (localStorage.getItem("nemontoAuthToken")) {
            getGeneralSettings()
            defaultLoading()
        } else {
            navigate('/')
        }
    }, []);

    async function getGeneralSettings() {
        try {
            const res = await apiHandler(GENERAL_SETTINGS, "POST", {
            })
            if (res.data?.response?.status === 200) {
                setGeneralSettings(res?.data?.data?.generalSettings)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const defaultLoading = () => {
        getAdsList(1)
        setPage(1)
    };

    const loadMore = (inView) => {
        if (inView) {
            if (page < maxPage) {
                getAdsList(page + 1)
                //console.log("scroll working...", page + 1)
                setPage(page + 1)
            }
        }
    };

    async function getAdsList(pageVal) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(GET_MY_ADS, "POST", {
                page: pageVal,
                limit: 10
            })
            if (res.data?.response?.status === 200) {
                setMaxPage(res?.data?.data?.userPosts?.meta?.last_page)
                if (pageVal === 1) {
                    setAdsList(res?.data?.data?.userPosts?.data || [])
                } else if (res?.data?.data?.userPosts?.meta?.total > 0) {
                    setAdsList(adsList.concat(res?.data?.data?.userPosts?.data))
                }
            } else {
                navigate('/')
                //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
                //console.log("profileRes",res)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    return (
        <>
            <LoaderModal showLoader={showLoader} />
            {
                showCreateAdModal ?
                    <CreateNewAd showCreateAdModal={showCreateAdModal} handleClose={handleClose} generalSettings={generalSettings} refreshApi={defaultLoading} /> : null
            }
            <div className="nmsl-layout">
                <div className="nmsl-main">
                        <div className="nmsl-page-header">
                            <div className="nmsl-header">
                                <h3 className="nmsl-title">My Ad Posts</h3>
                                {adsList?.length > 0 && <span className="nmsl-count-pill">{adsList.length}</span>}
                            </div>
                            <p className="nmsl-subtitle">Promote your recipes and reach more home cooks.</p>
                        </div>

                        <div className="nmsl-main-body">
                            {adsList?.length > 0 ? adsList.map((elm, i) => (
                                <AdCard key={elm?.id} elm={elm} getAdsList={defaultLoading} />
                            )) : (
                                <EmptyState icon="campaign" title="No ads yet" sub="Create your first advertise to reach more home cooks." />
                            )}
                            {
                                showMoreDataLoader ?
                                    <div className="text-center">
                                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                                    </div> : null
                            }
                            <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                        </div>
                    </div>

                    <aside className="nmsl-rail">
                        <div className="nmsl-card" style={{ cursor: 'pointer' }} onClick={() => { setShowCreateAdModal(true) }}>
                            <div className="nmsl-icon-btn" style={{ cursor: 'pointer' }}>
                                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>add</span>
                            </div>
                            <div className="nmsl-body">
                                <div className="nmsl-name">Create New Advertise</div>
                                <div className="nmsl-sub">Set up a new promoted post</div>
                            </div>
                        </div>
                        <PromoCard
                            label="Tip"
                            title={adTip.title}
                            sub={adTip.sub}
                            ctaText={adTip.ctaText}
                            to={adTip.to}
                        />
                        <PeopleYouMayKnowWidget limit={3} />
                        <MyStatsWidget />
                    </aside>
            </div>
        </>
    )

}

export default FriendList;